import { render, staticRenderFns } from "./mealDetails.vue?vue&type=template&id=2acbd8e8&scoped=true&"
import script from "./mealDetails.vue?vue&type=script&lang=js&"
export * from "./mealDetails.vue?vue&type=script&lang=js&"
import style0 from "./mealDetails.vue?vue&type=style&index=0&id=2acbd8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbd8e8",
  null
  
)

export default component.exports